function devtricker_session_isPostInReadingList(postId) {
    const key = 'devtricker_session_reading_list';
    const listJSON = sessionStorage.getItem(key);

    if (!listJSON) return false;

    try {
        const list = JSON.parse(listJSON);
        return !!list[postId];
    } catch (e) {
        return false;
    }
}

function devtricker_session_savePostInReadingList(postId) {
    const key = 'devtricker_session_reading_list';
    let list = {};

    try {
        const listJSON = sessionStorage.getItem(key);
        if (listJSON) {
            list = JSON.parse(listJSON);
        }
    } catch (e) {
        list = {};
    }

    list[postId] = {
        postId: postId,
        dateAdded: new Date().toISOString()
    };

    sessionStorage.setItem(key, JSON.stringify(list));

    devtricker_log(null, devtricker_log_level.INFO, "Post successfully added to reading list in sessionStorage.");
}

function devtricker_session_deletePostFromReadingList(postId) {
    const key = 'devtricker_session_reading_list';
    let list = {};

    try {
        const listJSON = sessionStorage.getItem(key);
        if (listJSON) {
            list = JSON.parse(listJSON);
        }

        if (list[postId]) {
            delete list[postId];
            sessionStorage.setItem(key, JSON.stringify(list));
            devtricker_log(null, devtricker_log_level.INFO, "Post successfully removed from the reading list in sessionStorage.");
        } else {
            throw new Error("Post not found in the reading list in sessionStorage.");
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}